import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { COMPLETE_STEP } from "basic-details/basicDetailsActions";
import {
  SET_ACTIVE_STEP,
  SHOW_CANCEL_SUBMISSION_DIALOG,
} from "submission/submissionActions";

import {
  getSubmitterIsCreator,
  isPersonalInfoStepLoading,
} from "common/selectors";
import { makeStyles } from "@material-ui/core/styles";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

import CreatorDetailsForm from "basic-details/components/CreatorDetailsForm";
import LoadingPanel from "general-components/LoadingPanel";
import PersonalDetailsForm from "basic-details/components/PersonalDetailsForm";
import StepPanelButtonBar from "general-components/StepPanelButtonBar";

import * as steps from "common/steps";
import {
  FIELD_BLURRED,
  COUNTRY_CHANGED,
  LOCAL_LIBRARY_CHANGED,
  REGION_CHANGED,
  ROLE_CHANGED,
  FIELD_CHANGED,
  SET_SHOW_LOCAL_LIBRARY_OTHER,
} from "basic-details/basicDetailsActions";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 2,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },

  section: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },

  sectionHeader: {
    marginBottom: theme.spacing(2),
  },
}));

const BasicDetails = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const loading = useSelector(isPersonalInfoStepLoading);
  const isSubmitterCreator = useSelector(getSubmitterIsCreator);

  const dispatch = useDispatch();
  const onPrevious = () =>
    dispatch({ type: SET_ACTIVE_STEP, step: steps.INTRO });
  const onNext = () => dispatch({ type: COMPLETE_STEP });
  const onCancel = () =>
    dispatch({ type: SHOW_CANCEL_SUBMISSION_DIALOG, show: true });

  const actions = {
    FIELD_BLURRED,
    COUNTRY_CHANGED,
    LOCAL_LIBRARY_CHANGED,
    REGION_CHANGED,
    ROLE_CHANGED,
    FIELD_CHANGED,
    SET_SHOW_LOCAL_LIBRARY_OTHER,
  };

  return loading ? (
    <LoadingPanel />
  ) : (
    <Paper classes={{ root: classes.root }} elevation={0}>
      {isSubmitterCreator ? (
        <div className={classes.section}>
          <div className={classes.sectionHeader}>
            <Typography variant="h2">
              {t("basic_about_you")}{" "}
              <Typography variant="body2">{t("basic_details_you")}</Typography>
            </Typography>
          </div>
          <PersonalDetailsForm actions={actions} />
        </div>
      ) : (
        <div className={classes.section}>
          <div className={classes.sectionHeader}>
            <Typography variant="h2">
              {t("basic_about_creator")}{" "}
              <Typography variant="body2">
                {t("basic_details_creator")}
              </Typography>
            </Typography>
          </div>
          <CreatorDetailsForm />
        </div>
      )}
      <div>
        <StepPanelButtonBar
          onNext={onNext}
          onPrevious={onPrevious}
          onCancel={onCancel}
        />
      </div>
    </Paper>
  );
};

export default BasicDetails;
